import { handleActions } from 'redux-actions';
import http from '../shared/http';
import intl from '../shared/intl';
import endpoints from '../../config/endpoints';
import _groupBy from 'lodash/groupBy';
import _mapValues from 'lodash/mapValues';
import _pick from 'lodash/pick';
import _uniqBy from 'lodash/uniqBy';
import { getCurrencyIcon } from '../../../shared/js/get-currency-icon';

const DATA_FETCH_SUCCESS = 'bm-accounts/data-fetch-success';
const DATA_FETCH_ERROR  = 'bm-accounts/data-fetch-error';

const ORDER_ACCOUNT_SUCCESS = 'bm-accounts/order-account-success';
const ORDER_ACCOUNT_ERROR  = 'bm-accounts/order-account-error';

const TOGGLE_POPUP = 'bm-accounts/toggle-popup';
const INIT_POPUP = 'bm-accounts/init-popup';
const CHANGE_POPUP_TYPE = 'bm-accounts/change-popup-type';

const TOGGLE_CATEGORY_FILTER = 'bm-accounts/toggle-category-filter';

// initialState state
const initialState = {
	data: null,
	tableData: null,
	isOpenOderPopup: false,
	popupType: 'order',
	popupAccountId: 0,
	selectedCategoryIds: [null],
	error: false
};

// actions
export const actions = {
	fetchData: () => dispatch => {
		const request = http({
			url: `${endpoints.BM_ACCOUNTS.MAIN}`,
			method:'get',
			actions: [
				DATA_FETCH_SUCCESS,
				DATA_FETCH_ERROR
			]
		});
		request(dispatch);
	},
	orderAccount: (id) => dispatch => {
		const request = http({
			url: endpoints.BM_ACCOUNTS.ORDER.replace('{id}', id),
			method:'post',
			actions:[
				ORDER_ACCOUNT_SUCCESS,
				ORDER_ACCOUNT_ERROR
			]
		});

		return request(dispatch)
			.then((action) => {
				if (action.type === ORDER_ACCOUNT_SUCCESS) {
					dispatch(actions.changePopupType('orderSuccess'));
				} else {
					dispatch(actions.togglePopup());
				}
			});
	},
	togglePopup: () => dispatch => {
		return dispatch({ type: TOGGLE_POPUP });
	},
	toggleCategoryFilter: (id) => dispatch => {
		return dispatch({ type: TOGGLE_CATEGORY_FILTER, payload: id });
	},
	initPopup: (popupAccountId) => dispatch => {
		dispatch({type: INIT_POPUP, payload: {popupAccountId}});

		return dispatch(actions.togglePopup());
	},
	changePopupType: (type) => dispatch => {
		const payload = { popupType: type };
		return dispatch({ type: CHANGE_POPUP_TYPE, payload });
	}
};

// reducers
const reducers = Object.assign({
	[DATA_FETCH_SUCCESS]: (state, action) => {
		const data = action.payload.data
			.map(item => ({...item, currency: getCurrencyIcon(item.currency)}));

		const tableDataGrouped = _groupBy(data, item => item.category_id);
		const tableData = _mapValues(tableDataGrouped, accounts => addCategoryRow(accounts));

		return { ...state, data, tableData: [].concat(...Object.values(tableData))};
	},
	[TOGGLE_POPUP]: (state, action) => {
		return { ...state, isOpenOderPopup: !state.isOpenOderPopup};
	},
	[INIT_POPUP]: (state, action) => {
		return { ...state, ...action.payload};
	},
	[CHANGE_POPUP_TYPE]: (state, action) => {
		return { ...state, ...action.payload};
	},
	[DATA_FETCH_ERROR]: state => {
		return { ...state, error: true };
	},
	[TOGGLE_CATEGORY_FILTER]: (state, action) => {
		const wasSelected = state.selectedCategoryIds.includes(action.payload);
		const selectedCategoryIds = wasSelected
			? state.selectedCategoryIds.filter(sci => sci !== action.payload)
			: [...state.selectedCategoryIds, action.payload];

		return { ...state, selectedCategoryIds};
	}
});

//functions

function addCategoryRow(accounts = []) {
	return [
		{ isCategoryRow: true, ..._pick(accounts[0], [ 'category_name', 'category_id' ])},
		...accounts
	];
}

export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	getData: state => state.bmAccounts.data,
	getAccountDataSelector: state => accountId => {
		if (!state.bmAccounts.data || !accountId) { return ;}

		return state.bmAccounts.data.find(item => item.id === Number(accountId));
	},
	getPopupAccountData: state  => {
		return state.bmAccounts.data
			&& state.bmAccounts.data.find(acc => acc.id === state.bmAccounts.popupAccountId);
	},
	getTableData: state => {
		const filterCategories = selectors.getCategories(state);
		const selectedCategoryIds = selectors.getSelectedCategoryIds(state);

		if (filterCategories && selectedCategoryIds ) {
			return state.bmAccounts.tableData.filter(td =>
				selectedCategoryIds.some(sci => sci === td.category_id || sci === null)
			);
		}
		return state.bmAccounts.tableData;
	},
	getCategories: state => {
		const uniqByCategories = _uniqBy(state.bmAccounts.data, 'category_id');

		if (uniqByCategories && uniqByCategories.length) {
			return [
				{category_id: null, category_name: selectors.getIntl(state)('Все')},
				...uniqByCategories.map(ct => _pick(ct, ['category_name', 'category_id']))
			];
		}
	},
	getIsOpenPopup: state => state.bmAccounts.isOpenOderPopup,
	getSelectedCategoryIds: state => state.bmAccounts.selectedCategoryIds,
	getPopupType: state => state.bmAccounts.popupType,
	getError: state => state.bmAccounts.error,
	getIntl: state => intl(state)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/bm-accounts/index.js